export const LOADING_FACTOR_TEMPLATE = "LOADING_FACTOR_TEMPLATE";
export const SAVE_LOADING_FACTOR_TEMPLATE = "SAVE_LOADING_FACTOR_TEMPLATE";
export const GET_FACTOR_TEMPLATE = "GET_FACTOR_TEMPLATE";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_COPY_FAIL = "FORM_COPY_FAIL";
export const FACTOR_TEMPLATE_FAIL = "FACTOR_TEMPLATE_FAIL";
export const LOADING_FACTOR_TEMPLATE_BY_ID = "LOADING_FACTOR_TEMPLATE_BY_ID";
export const GET_FACTOR_TEMPLATE_BY_ID = "GET_FACTOR_TEMPLATE_BY_ID";

